import "./Header.css";

interface HeaderProps {
    variant?: 'landing' | 'app';
    onBookDemoClick?: () => void;
    onLogin?: () => void;
    onLogout?: () => void;
}

export function Header({ variant = 'landing', onBookDemoClick, onLogin, onLogout }: HeaderProps) {
    const logoSrc = "/overwatchai-logo-light.png";

    return (
        <header className="header">
            <div className="header-left">
                <img className="header-logo" src={logoSrc} alt="OverWatchAI logo" />
                <div className="header-title">
                    <span className="ow">OverWatch</span>
                    <span className="ai">AI</span>
                </div>
            </div>

            <div className="header-right">
                {variant === 'landing' ? (
                    <>
                        <button className="login-btn" onClick={onLogin}>
                            Login
                        </button>
                        <button className="book-demo-btn" onClick={onBookDemoClick}>
                            Book a Demo
                        </button>
                    </>
                ) : (
                    <button className="logout-btn" onClick={onLogout}>
                        Logout
                    </button>
                )}
            </div>
        </header>
    );
}
